import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import { MobileContext } from '../../providers/MobileProvider';

const propTypes = {
  pageName: PropTypes.string.isRequired,
};

const useStyles = makeStyles(theme => ({
  appBar: {
    backgroundColor: '#ffffff',
  },
  toolbar: {
    color: '#3f82bf',
    padding: theme.spacing(0, 4),
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(0, 2),
    },
  },
  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
  },
}));

function Header({ pageName }) {
  const { changeOpen } = useContext(MobileContext);
  const classes = useStyles();

  const handleDrawerToggle = () => {
    changeOpen();
  };

  return (
    <AppBar classes={{ root: classes.appBar }} elevation={0} position="sticky">
      <Toolbar classes={{ root: classes.toolbar }}>
        <IconButton
          color="inherit"
          aria-label="open drawer"
          edge="start"
          onClick={handleDrawerToggle}
          className={classes.menuButton}
        >
          <MenuIcon />
        </IconButton>
        <Typography variant="h6">
          {pageName}
        </Typography>
      </Toolbar>
    </AppBar>
  );
}

Header.propTypes = propTypes;

export default Header;
